import AjaxService from 'services/ajax-service';

import { handleServerError } from 'shared-services/error-service';
import { normalizeDateForServer } from '../utils/date';

export const fetchUserState = () => {
    return AjaxService({
        method: 'get',
        url: 'state'
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateChatsUserState = ({ visible }) => {
    return AjaxService({
        method: 'post',
        url: 'state/chats',
        data: {
            ids: visible
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateSubteamsUserState = ({ collapsed }) => {
    return AjaxService({
        method: 'post',
        url: 'state/subteams',
        data: {
            ids: collapsed
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateProjectUserState = (projectId, { hiddenColumns, columns, collapsedGroups }) => {
    return AjaxService({
        method: 'post',
        url: `state/projects/${projectId}`,
        data: {
            hidden: hiddenColumns,
            columns,
            collapsed: collapsedGroups
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateAllTasksUserState = ({ tasks }) => {
    return AjaxService({
        method: 'post',
        url: 'state/all_tasks',
        data: {
            collapsed: tasks.collapsedGroups,
            hidden: tasks.hiddenColumns,
            columns: tasks.columns
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateMyTasksUserState = ({ tasks, calendarCollapsed }) => {
    return AjaxService({
        method: 'post',
        url: 'state/my_tasks',
        data: {
            collapsed: tasks && tasks.collapsedGroups,
            hidden: tasks && tasks.hiddenColumns,
            columns: tasks && tasks.columns,
            calendarCollapsed,
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateWorkloadsState = ({ type, start, end }) => {
    return AjaxService({
        method: 'post',
        url: 'state/workloads',
        data: {
            type,
            start: normalizeDateForServer(start),
            end: normalizeDateForServer(end)
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}
